import { inject, Injectable } from '@angular/core';
import { DialogService } from 'nebula-ui-kit';
import { EconomicActivityService } from './actividades-economicas.service';
import { EconomicActivityModal } from '../../domain/actividad-economica-modal';
import { map, Observable } from 'rxjs';
import { SelectDialogComponent } from '../../../select-dialog/select-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ActividadesEconomicasModalService {
  readonly dialogService = inject(DialogService);
  readonly activitiesService = inject(EconomicActivityService);
  openSelector(title: string, currentValue?: string): Observable<EconomicActivityModal | null> {
    const columns = [
      { key: 'codigo', label: 'Código', sortable: true, width: '30%' },
      { key: 'descripcion', label: 'Nombre', sortable: true, width: '70%' },
    ];
    const loadDataFn = async (
      params: any,
    ): Promise<{ data: EconomicActivityModal[]; total: number }> => {
      const page = params.page - 1;
      const size = params.limit || 10;
      const searchTerm = params.search || '';
      const sortColumn = params.sortColumn || '';
      const sortDirection = params.sortDirection || '';

      const response = await this.activitiesService
        .getAllEconomicActivities(page, size, searchTerm, sortColumn, sortDirection)
        .pipe(
          map((response: any) => {
            return {
              data: response.content || [],
              total: response.totalElements || 0,
            };
          }),
        )
        .toPromise();

      return response || { data: [], total: 0 };
    };

    const dialogRef = this.dialogService.open(SelectDialogComponent, {
      data: {
        title: title,
        columns: columns,
        multiSelect: false,
        searchPlaceholder: 'Buscar por código o nombre...',
        loadDataFn: loadDataFn,
        itemIdKey: 'id',
        displayKey: 'codigo',
        selectedItems: currentValue ? [{ codigo: currentValue, nombre: currentValue }] : [],
        pageSize: 10,
        pageSizeOptions: [10, 25, 50, 100],
      },
      size: 'lg',
      width: '700px',
    });

    return dialogRef
      .afterClosed()
      .pipe(
        map((selected: EconomicActivityModal[]) =>
          selected && selected.length > 0 ? selected[0] : null,
        ),
      );
  }
}
